(ns core.front.config
  (:require [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-config
  (fn [_ _]
    {:comm/command {:command    :status/config
                    :method     :get
                    :on-success [::fetch-config.success]}}))

(rf/reg-event-db ::fetch-config.success
  (fn [db [_ _ data]]
    (assoc db ::config data)))

(defn db->config
  [db]
  (::config db))

(rf/reg-sub ::config
  :-> db->config)

(rf/reg-sub ::country
  :<- [::config]
  (fn [config _]
    ;; Default to Canada if nothing is yet set
    (:country config i18n-model/default-country)))

(rf/reg-sub ::country-kw
  :<- [::country]
  (fn [country _]
    (some-> country str/upper-case keyword)))

(rf/reg-sub ::address-countries
  :<- [::config]
  :-> :address-countries)

(rf/reg-sub ::system-country-subdivisions
  :<- [::country-kw]
  :<- [::address-countries]
  (fn [[country country-subdivs] _]
    (get country-subdivs country)))

(rf/reg-sub ::env-name
  :<- [::config]
  :-> :env-name)
